import { render, staticRenderFns } from "./PropertyDescriptionModal.vue?vue&type=template&id=3a2905ca&"
import script from "./PropertyDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./PropertyDescriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports